export default {
	getByUser(params, cb, ecb) {
		this.http
			.get('/message/getByUser', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/message/search', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	fetchNew(topId, cb, ecb) {
		this.http
			.get('/message/fetchNew/' + topId)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/message/update', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	send(form, cb, ecb) {
		this.http
			.post('/message/send', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	remove(id, cb) {
		this.http.get('/message/remove/' + id, {}).then((r) => {
			if (cb) cb(r)
		})
	},
	searchReply(params, cb, ecb) {
		this.http
			.get('/message/searchReply', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	status(id, to, cb, ecb) {
		this.http
			.get(`/message/status/${id}/${to}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	markAsRead(id, cb, ecb) {
		this.http
			.get(`/message/markAsRead/${id}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
